// Приём заявок открыт: регистрация доступна всем без ключа в ссылке.
// Чтобы закрыть приём, поставить false: останется вход и регистрация по ссылке с ключом.
export const IS_REGISTRATION_OPEN = true

export const REGISTER_SECRET_KEY_PARAM = 'key'
export const REGISTER_SECRET_KEY = '86ed67d120cf31057e5ef4ca1c650070'
